<template>
  <div>
    <v-card>
    <v-card-title>
      Enrollments
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        clearable
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="courses"
      :search="search"
      :loading="loading"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.course_type }}</td>
        <td class="text-xs-center">{{ props.item.name }}</td>
        <td class="text-xs-center">{{ props.item.quota_total }}</td>
        <td class="text-xs-center">{{ props.item.quota }}</td>
        <td class="text-xs-center">
          <v-btn @click="paidDetail(props.item.paid_detail)" small color="primary" dark>
            {{ getPaidDistinctTotal(props.item.paid_detail) }}
          </v-btn>
        </td>
        <td class="text-xs-center">
          <v-btn @click="pendingDetail(props.item.pending_detail)" small color="accent" dark>
            {{ getPendingDistinctTotal(props.item.pending_detail) }}
          </v-btn>
        </td>
        <td class="text-xs-center">
          {{ getPaidDistinctTotal(props.item.paid_detail) + getPendingDistinctTotal(props.item.pending_detail) }}
        </td>
      </template>
    </v-data-table>
  </v-card>
  <v-dialog
    v-model="paid_modal"
    max-width="700px"
    transition="dialog-transition"
    scrollable

  >
    <v-card>
      <v-card-title>
        Reservas pagadas
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search_paid"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="paid_detail_headers"
        :items="paid_detail"
        :search="search_paid"
      >
        <template slot="items" slot-scope="props">
          <td v-if="props.item.student_id != 0" class="text-xs-center">{{ props.item.student.family_id }}</td>
          <td v-else class="text-xs-center">Ext</td>
          <td v-if="props.item.student_id != 0" class="text-xs-center">{{ props.item.student.full_name }}</td>
          <td v-else class="text-xs-center">{{ props.item.student_ext.full_name }}</td>
          <td class="text-xs-center">{{ props.item.schedule.name }}</td>
          <td class="text-xs-center">{{ $t(`reports.general.status.${props.item.status}`) }}</td>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-layout row wrap justify-center>
            <v-btn @click="paid_modal = false" color="primary">
              {{ $t('close') }}
            </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="pending_modal"
    max-width="700px"
    transition="dialog-transition"
    scrollable
  >
    <v-card>
      <v-card-title>
        Reservas pendientes
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search_pending"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="pending_detail_headers"
        :items="pending_detail"
        :search="search_pending"
      >
        <template slot="items" slot-scope="props">
          <td v-if="props.item.student_id != 0" class="text-xs-center">{{ props.item.student.family_id }}</td>
          <td v-else class="text-xs-center">Ext</td>
          <td v-if="props.item.student_id != 0" class="text-xs-center">{{ props.item.student.full_name }}</td>
          <td v-else class="text-xs-center">{{ props.item.student_ext.full_name }}</td>
          <td class="text-xs-center">{{ props.item.schedule.name }}</td>
          <td class="text-xs-center">{{ $t(`reports.general.status.${props.item.status}`) }}</td>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-layout row wrap justify-center>
            <v-btn @click="pending_modal = false" color="primary">
              {{ $t('close') }}
            </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'enrollment-report-view',
    data() {
      return {
        headers: [
          { text: this.$t('reports.headers.course_type'), align: 'center', value: 'course_type' },
          { text: this.$t('reports.headers.course'), align: 'center', value: 'name' },
          { text: this.$t('reports.headers.quota'), align: 'center', value: 'quota_total' },
          { text: this.$t('reports.headers.quota_available'), align: 'center', value: 'quota' },
          { text: this.$t('reports.headers.paid'), align: 'center', value: 'paid' },
          { text: this.$t('reports.headers.pending'), align: 'center', value: 'pending' },
          { text: this.$t('reports.headers.reserve_total'), align: 'center', value: 'reserve_total' },
        ],
        courses: [],
        loading: false,
        search: '',
        paid_detail: [],
        pending_detail: [],
        paid_modal: false,
        pending_modal: false,
        paid_detail_headers: [
          { text: this.$t('reports.headers.family'), align: 'center', value: 'student.family_id' },
          { text: this.$t('reports.headers.student'), align: 'center', value: 'student.full_name' },
          { text: this.$t('reports.headers.schedule'), align: 'center', value: 'schedule.name' },
          { text: this.$t('reports.headers.status'), align: 'center', value: 'status' },
        ],
        pending_detail_headers: [
          { text: this.$t('reports.headers.family'), align: 'center', value: 'student.family_id' },
          { text: this.$t('reports.headers.student'), align: 'center', value: 'student.full_name' },
          { text: this.$t('reports.headers.schedule'), align: 'center', value: 'schedule.name' },
          { text: this.$t('reports.headers.status'), align: 'center', value: 'status' },
        ],
        search_paid: '',
        search_pending: '',
      }
    },
    created () {
      this.getReportData();
    },
    methods: {
      getReportData() {
        this.loading = true
        axios.get('/api/extracurriculares/report/admin')
          .then(resp => {
            if (resp.status === 200) {
              resp.data.data.forEach(course => {
                if (course.active_schedules.length > 0) {
                  var quota_total = course.quota;
                } else {
                  var quota_total = 0;
                }
                this.courses.push({
                  course_type: course.course_type.name,
                  name: course.name,
                  quota_total: quota_total,
                  quota: course.availablequotas,
                  paid: course.paid_reservations.length,
                  pending: course.pending_reservations.length,
                  paid_detail: course.paid_reservations,
                  pending_detail: course.pending_reservations,
                })
              })
            }
            this.loading = false
          })
          .catch(error => {
            this.loading = false
          })
      },
      formatNumber(number) {
        if(!number || typeof number === 'undefined') {
            return 0;
        } else {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
      },
      paidDetail(detail) {
        this.paid_modal = true
        this.paid_detail = detail
      },
      pendingDetail(detail) {
        this.pending_modal = true
        this.pending_detail = detail
      },
      getPaidDistinctTotal(detail) {
        const distinctStudents = [...new Set(detail.map(det => det.student_id))]
        return distinctStudents.length
      },
      getPendingDistinctTotal(detail) {
        const distinctStudents = [...new Set(detail.map(det => det.student_id))]
        return distinctStudents.length
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/reports/admin.vue